export const FaqScreen = () => `
    <div id="faq-screen" class="screen">
        <div class="clean-portal-container" style="width: 100% !important; max-width: 1200px !important;">
            <h2 class="screen-title">S.S.S.</h2>
            
            <div style="text-align: left; margin-top: 40px; font-size: 1.15rem; line-height: 1.9; color: var(--text-white);">
                <div style="margin-bottom: 35px;">
                    <h3 style="color: var(--accent-blue); font-size: 1.4rem; margin-bottom: 10px;">Gaddar Bilgi Nedir?</h3>
                    <p style="text-align: left !important; margin: 0 !important; max-width: 100% !important;">
                        Gaddar Bilgi, farklı kategorilerde (Akademik, Gündem vb.) yarışabileceğin, hem eğlenip hem öğrenebileceğin yeni nesil bir bilgi yarışmasıdır.
                    </p>
                </div>

                <div style="margin-bottom: 35px;">
                    <h3 style="color: var(--accent-blue); font-size: 1.4rem; margin-bottom: 10px;">Nasıl Puan Kazanırım?</h3>
                    <p style="text-align: left !important; margin: 0 !important; max-width: 100% !important;">
                        Soruları doğru cevaplayarak puan kazanırsın. Soruyu ne kadar hızlı cevaplarsan o kadar çok puan alırsın. Zorluk seviyesi arttıkça puan katsayısı da artar.
                    </p>
                </div>

                <div style="margin-bottom: 35px;">
                    <h3 style="color: var(--accent-blue); font-size: 1.4rem; margin-bottom: 10px;">Joker Hakkım Var mı?</h3>
                    <p style="text-align: left !important; margin: 0 !important; max-width: 100% !important;">
                        Yarışma esnasında kullanabileceğin Pas ve Yarı Yarıya (50:50) joker hakların bulunur. Her joker yarışma başına bir kez kullanılabilir.
                    </p>
                </div>

                <div style="margin-bottom: 35px;">
                    <h3 style="color: var(--accent-blue); font-size: 1.4rem; margin-bottom: 10px;">Rütbe Sistemi Nasıl Çalışıyor?</h3>
                    <p style="text-align: left !important; margin: 0 !important; max-width: 100% !important;">
                        Kazandığın puanlar seviyeni belirler. Belirli puan limitlerine ulaştığında yeni askeri rütbelere terfi edersin. Profil ekranından güncel rütbeni görebilirsin.
                    </p>
                </div>

                <div style="margin-bottom: 35px;">
                    <h3 style="color: var(--accent-blue); font-size: 1.4rem; margin-bottom: 10px;">Mobil Uygulamanız Var mı?</h3>
                    <p style="text-align: left !important; margin: 0 !important; max-width: 100% !important;">
                        Evet! Google Play Store üzerinden "Gaddar Bilgi" uygulamasını indirerek Android cihazlarınızda çok daha akıcı bir şekilde yarışabilirsiniz.
                    </p>
                </div>
            </div>
        </div>
    </div>
`;
